<cipx-drawer-template
  #drawerTemplate
  [fixed]="fixed"
  [sizeType]="sizeType"
  [showUpBand]="showUpBand"
  [mode]="mode"
  [name]="name"
  [opened]="opened"
  [position]="position"
  [transparentOverlay]="transparentOverlay"
  [disableOverlayClose]="disableOverlayClose"
  [disableOverlay]="disableOverlay"
  [showCloseButton]="showCloseButton"
  [title]="title"
  [showHeader]="showHeader"
  [showBackButton]="showBackButton"
  (openedChanged)="onOpenedChanged($event)"
  (closeClick)="onCloseClick()"
  (backClick)="onBackClick()"
  (viewInitialized)="onTemplateViewInit()">
  <!-- Pass through any ng-content -->
  <ng-content></ng-content>
</cipx-drawer-template>
